﻿import ko from 'knockout'
import { IBinder, IBehaviorBinding, ICellBinding } from "./ibinder"
import Utility from "../utility"
import $ from 'jquery';

export class RemoveRowBinder implements IBinder {
  public getElements(root: JQuery): JQuery {
    return root.find(".et-remove-row");
  }

  public getBinding(element: JQuery): IBehaviorBinding {
    return {
      bindingName: "click",
      bindTo: "$parent.removeRow",
      createEmptyValue: () => null,
      behavior: {
        name: "removeRow",
        build: data => (item) => {
          if (!Utility.isBlankItem(item)) {
            if (!data.RemovedRows)
              data.RemovedRows = ko.observableArray();
            data.RemovedRows.push(item);
          }
          data.Rows.remove(item);
          return true;
        }
      }
    }
  }
}
